export default __webpack_public_path__ + "static/media/MCRN.8b2ceb74.svg";